// src/routes/parentRoutes.js
// Routes specific to parent user type

import React from "react";

// Import parent-specific pages
import Children from "../pages/parent/Children";
import ChildControl from "../pages/parent/ChildControl";
import EventDetail from "../pages/parent/EventDetail";

/**
 * Parent Routes Configuration
 * 
 * Routes available to users with accountType: "parent"
 * These routes allow parents to:
 * - Manage their children relationships
 * - Monitor children's events and activities
 * - View children's social feed activity
 */
export const parentRoutes = [
  // ==================== CHILDREN MANAGEMENT ====================
  {
    path: "/parent/children",
    element: <Children />,
    description: "Manage parent-child relationships and select child to control"
  },

  // ==================== CHILD CONTROL VIEWS ====================
  {
    path: "/parent/child-control/:view",
    element: <ChildControl />,
    description: "Control and monitor selected child's activities (full, events, feed, team)"
  },

  // ==================== EVENT DETAIL ====================
  {
    path: "/parent/event/:eventId",
    element: <EventDetail />,
    description: "View detailed information about a specific event for the selected child"
  },
]; 